import { render } from "./SongPage.vue?vue&type=template&id=a44ee07a&scoped=true&ts=true"
import script from "./SongPage.vue?vue&type=script&lang=ts"
export * from "./SongPage.vue?vue&type=script&lang=ts"

import "./SongPage.vue?vue&type=style&index=0&id=a44ee07a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Azizi\\Documents\\Personal\\Projects\\Slideshow\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a44ee07a"]])

export default __exports__